import React from "react";
import { ReactSVG } from "react-svg";

const Person = React.memo(({ gender, option, remix, backdropAsset, head, top, bottom }) => {
  return (
    <>
      <img
        className="canvas__section canvas__section_bg z1"
        src={backdropAsset}
        alt="backdrop"
      />
      <div className="canvas__group z2">
        <img className="canvas__section" src={head} alt="Head" />
        <ReactSVG
          className="canvas__section"
          src={`/images/masks/${gender}/head/${remix?.head}.svg`}
        />
        <ReactSVG
          className="canvas__section"
          src={`/images/masks/${gender}/head/${remix?.head}_1.svg`}
        />
      </div>
      <div className="canvas__group z4">
        <img className="canvas__section" src={top} alt="Top" />
        <ReactSVG
          className="canvas__section"
          src={`/images/masks/${gender}/${option}/top/${remix?.top}.svg`}
        />
        <ReactSVG
          className="canvas__section"
          src={`/images/masks/${gender}/${option}/top/${remix?.top}_1.svg`}
        />
      </div>
      <div className="canvas__group z3">
        <img className="canvas__section" src={bottom} alt="Bottom" />
        <ReactSVG
          className="canvas__section"
          src={`/images/masks/${gender}/${option}/bottom/${remix?.bottom}.svg`}
        />
        <ReactSVG
          className="canvas__section"
          src={`/images/masks/${gender}/${option}/bottom/${remix?.bottom}_1.svg`}
        />
      </div>
    </>
  );
});

Person.displayName = 'Person';

export default Person;